export default "__VITE_ASSET__Bplg1QEb__"